"use strict";

angular.module("admin")
	.controller("AdminImportsParametersCtrl", ["$scope", "toastr", "AdminClientsService", "$location",
		function ($scope, toastr, AdminClientsService, $location) {

			AdminClientsService.getCurrentClient().then((client) => {
				$scope.data.client = client;
			});

			$scope.edit = function () {
				AdminClientsService.editClientImportParameters($scope.data.client).then((response) => {
					const data = response.data;
					toastr.success("", "Les paramètres d'import pour l'organisation " + data.code + " sont mis à jour");
					$location.path("/admin/import-configuration");
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la mise à jour des paramètres d'import. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			};
		}
	]);
